import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SearchEventsService} from '../search-container/search.service';
import {ProductDataSet} from '../../models/product-data-set';
import {ActivatedRoute} from '@angular/router';
import {GoogleAnalyticsService} from "../../services/google-analytics.service";
import {ProductService} from "../../services/product.service";
import {ProductsGridComponent} from "../products/products-grid/products-grid.component";

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit , OnDestroy {

  @ViewChild('gridComponent') gridComponent: ProductsGridComponent;
  isSearchGrid = false;
  searchKeyword = '';
  dataset: ProductDataSet = new ProductDataSet();
  value = '';
  searchIsActive = false;


  categoryfilterChanged;
  searchTriggeredEvent;
  constructor(private searchService: SearchEventsService ,
              private googleService: GoogleAnalyticsService,
              private productService: ProductService,
              private route: ActivatedRoute) {
    // this.searchTriggeredEvent = this.searchService.searchTriggeredEvent.subscribe(value => {
    //   console.log('value from the subsecribtion');
    //   console.log(value);
    //   this.value = value;
    //   this.changeSearchedProduct();
    //
    //
    // });


  }

  ngOnInit(): void {
    this.value = this.route.snapshot.paramMap.get('value');

    this.changeSearchedProduct();



    this.categoryfilterChanged = this.productService.ProductCategoryFilterChangedEvent$.subscribe(category_ids => {


      if (category_ids.length != 0) {


        this.dataset = new ProductDataSet();
        this.dataset.pushParams('category_id', category_ids.toString(), 'in');
        this.gridComponent.products = [];
        this.gridComponent.fetchProductDataSet();
        // if (this.gridComponent) {
        //   this.gridComponent.setProductDataset(this.dataset);
        //   this.gridComponent.fetchProductDataSet();
        // }

      }
      else {

        this.gridComponent.products = [];
        this.dataset.clearParams();
        this.changeSearchedProduct();

      }
    });

    //localStorage.removeItem('searchKeyword');

  }

  changeSearchedProduct() {

    const new_dataset = new ProductDataSet();
    this.isSearchGrid = true;
    this.searchKeyword = this.value;

    //this.googleService.eventEmitter("search", 'ecommerce', 'search', this.searchKeyword, 10);

    const keywords_arr = this.value.split(' ');

    keywords_arr.forEach(keyword => {

      if (keyword == ' ' || keyword == '') {
        return;
      }

      new_dataset.clearParams();

      new_dataset.pushParams('name', ('%' + keyword + '%'), 'like');
      new_dataset.pushParams('description', ('%' + keyword + '%'), 'like');
      new_dataset.pushParams('sku', ('%' + keyword + '%'), 'like');
      new_dataset.pushParams('brand', ('%' + keyword + '%'), 'like');
    });

    this.dataset = new_dataset;
    if(this.gridComponent != undefined) {
      this.gridComponent.setProductDataset(new_dataset);
      this.gridComponent.fetchProductDataSet();
    }

  }

  ngOnDestroy(): void {


    if(this.categoryfilterChanged != undefined)
    {
      this.categoryfilterChanged.unsubscribe();
    }


  }

}
